module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/YourInvestor-2fc366aa9c5e4697e3a43ddf708adc80.png";